import { ModelBase } from 'store/model-base';

export class CmsBillingStatement extends ModelBase {
    public static storeName: string = 'cmsBillingStatement';

    public summaryContents: CmsStatementSummary[];
    public expandIcon: CmsMediaImage;
    public checkmarkIcon: CmsMediaImage;
    public pastPlanChange: string;
    public dataSection: CmsStatementData;
    public serviceSection: CmsStatementService;
    public paymentsAndCredit: CmsPaymentsAndCredit;
    public serviceCreditTitle: string;
    public creditReversalTitle: string;
    public oneTimeFeeTitle: string;
    public oneTimeFeeSubTitle: string;
    public tax: CmsTax;
    public legacyText: string;
    public autoPay: string;
    public footNote: string;
    public chargeUnits: CmsStatementChargeUnits;
    public totalHeader: string;
    public paidFullLabel: string;
    public seg4PlanInfoDescription: string;
    public seg4PlanInfoDescriptionMoreLines: string;
    public multiLinePricingResiInstructionlink: string;
    public multiLinePricingCBMInstructionlink: string;
    public servicePromotions: ServicePromotions;
    public accountLevelFees: CmsAccountLevelFees;
}
